import { useEffect } from 'react';
import { attemptedActionStore } from 'helpers/attemptedActionStore';
import {
    AuthenticatedActions,
    AnyAuthenticatedUserAction,
    DownloadableItem,
} from 'types';

export const useStoreAttemptedDownloadAction = (
    downloadableItem: DownloadableItem | undefined,
    readyToStore: boolean,
) =>
    useEffect(() => {
        if (readyToStore && downloadableItem) {
            const attemptedDownload: AnyAuthenticatedUserAction = {
                type: AuthenticatedActions.downloadItem,
                args: [downloadableItem],
            };

            attemptedActionStore.set(attemptedDownload);
        }
    }, [readyToStore, downloadableItem]);
